import axios from "axios"

export const MLS_PURCHASE_LINK_HEADER = "X-MLS-Purchase-Link"
export const MLS_PAYMENT_LINK_HEADER = "X-MLS-Payment-Link"

function createLinkClient(header, signature) {
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { [header]: signature },
  })
}

/**
 * API client for the /buy-mls page. The signed link is its only credential;
 * the backend accepts it on the Purchase MLS endpoints and nowhere else.
 */
export function createMlsPurchaseLinkClient(signature) {
  return createLinkClient(MLS_PURCHASE_LINK_HEADER, signature)
}

/** API client for the /pay-mls page; works on the payment endpoints only. */
export function createMlsPaymentLinkClient(signature) {
  return createLinkClient(MLS_PAYMENT_LINK_HEADER, signature)
}

const FALLBACK_MESSAGE =
  "This MLS purchase link isn't valid. Ask SmartSetter for a new one."

/** Message for a link the backend refused (expired, invalid, used). */
export function linkErrorMessage(error) {
  const detail = error?.response?.data?.detail
  return typeof detail === "string" && detail ? detail : FALLBACK_MESSAGE
}
